import {formatCurrency} from '@angular/common';
import {Component, Inject, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {v4 as uuidv4} from 'uuid';
import {ServiceAppModels} from 'src/app/models/serviceapp-models';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {ZahlenFormatPipe} from 'src/app/pipes/zahlen-format.pipe';

@Component({
  selector: 'app-pos-mutation',
  templateUrl: './pos-mutation.component.html',
  styleUrls: ['./pos-mutation.component.scss'],
  encapsulation : ViewEncapsulation.None
})
export class PosMutationComponent implements OnInit {

  @Input() formGroup: UntypedFormGroup;
  public currAnzahl: number = 0.0;
  public currEinheit: string = "";
  public currPreissumme: string = "0.00";
  private currPreissummeValue: number = 0.0;
  public currLaenge: number = 0.0;
  public currBreite: number = 0.0;
  public currDicke: number = 0.0;
  public currPreis: number = 0.0;
  public currPreisFaktor: number = 1.0; // für m2/m3
  private currPreisProMass: string = "";
  private currPreisProMassValue: number = 0.0
  public currMengeEinheit: string = "";
  public roFields: boolean = false;
  public showGoodwill: boolean = false;
  public showExpense: boolean = false;
  public isWLArticle: boolean = false;

  /* Felder */
  fldArtikelNummerKey: string = "fldArtikelnummer";
  fldBezeichnungKey: string = "fldBezeichnung";
  fldAnzahlKey: string = "fldAnzahl";
  fldEinheitKey: string = "fldEinheit";
  fldPreisProEinheitKey: string = "fldPreisProEinheit";
  fldPreisProMassKey: string = "fldPreisProMass";
  fldTotalPreisKey: string = "fldTotalPreis";
  fldLaengeKey: string = "fldLaenge";
  fldBreiteKey: string = "fldBreite";
  fldDickeKey: string = "fldDicke";
  fldMengeKey: string = "fldMenge";
  fldMengeTotalKey: string = "fldMengeTotal";
  fldKulanzKey: string = "fldKulanz";
  fldSpesenKey: string = "fldSpesen";

  public errormsg: string = "";
  public hasError: boolean = false;

  private productEntry?: ServiceAppModels.SA_ProductEntry;
  private currServicePosID: string = "";


  constructor(
    public dialogRef: MatDialogRef<PosMutationComponent>,
    private swissSettings: SwissSettingsService,
    private _zahlenFormatPipe: ZahlenFormatPipe,
    @Inject(MAT_DIALOG_DATA) public data: ServiceAppModels.SA_DataForArticleMutation) {

    this.showGoodwill = this.data.sA_Anwender!.sA_ShowGoodwill! == 1;
    this.showExpense = this.data.sA_Anwender!.sA_ShowExpense! == 1;

    this.formGroup = new UntypedFormGroup({
      fldMitarbeiter: new UntypedFormControl(),
      fldArtikelnummer: new UntypedFormControl(),
      fldBezeichnung: new UntypedFormControl(),
      fldAnzahl: new UntypedFormControl(),
      fldEinheit: new UntypedFormControl(),
      fldPreisProEinheit: new UntypedFormControl(),
      fldPreisProMass: new UntypedFormControl(),
      fldTotalPreis: new UntypedFormControl(),
      fldLaenge: new UntypedFormControl(),
      fldBreite: new UntypedFormControl(),
      fldDicke: new UntypedFormControl(),
      fldMenge: new UntypedFormControl(),
      fldMengeTotal: new UntypedFormControl(),
      fldKulanz: new UntypedFormControl(),
      fldSpesen: new UntypedFormControl()
    });
    if(this.swissSettings.getWebConfig().debugMode)
      console.log("Konstruktor - pos-mutation", data)
  }

  ngOnInit(): void {
    if(this.swissSettings.getWebConfig().debugMode)
      console.log("Daten in Produkterfassung: ", this.data);

    if(this.data.editProdukt) // Bestehendes Produkt wurde übergeben
    {
      this.currServicePosID = this.data.editProdukt.servicePosID;
      if(this.swissSettings.getWebConfig().debugMode)
        console.log("Bestehendes Produkt: ", this.data.editProdukt);
      this.formGroup.controls[this.fldArtikelNummerKey].setValue(this.data.editProdukt.artikelnummer);
      if(this.data.editProdukt.bezeichnung)
        this.formGroup.controls[this.fldBezeichnungKey].setValue(this.data.editProdukt.bezeichnung);
      this.currAnzahl =  this.data.editProdukt.anzahl;
      this.formGroup.controls[this.fldAnzahlKey].setValue(this.data.editProdukt.anzahl);
      if(this.data.editProdukt.einheit) {
        this.formGroup.controls[this.fldEinheitKey].setValue(this.data.editProdukt.einheit);
        this.currEinheit = this.data.editProdukt.einheit;
      }
      // Die Einheit darf bei WL-Artikel nicht geändert werden.
      if(this.data.editProdukt.createdByWL) {
        this.isWLArticle = true;
        this.roFields = true;
      }
      if(this.data.editProdukt.preisProEinheit) {
        this.currPreis = this.data.editProdukt.preisProEinheit;
        this.formGroup.controls[this.fldPreisProEinheitKey].setValue(this.data.editProdukt.preisProEinheit);
      }
      if(this.data.editProdukt.preisTotal) {
        this.currPreissumme = formatCurrency(this.data.editProdukt.preisTotal, 'de-CH', 'CHF', '1.2-2').replace(',', '.');
        this.formGroup.controls[this.fldTotalPreisKey].setValue(this.currPreissumme);
      }
      if(this.data.editProdukt.laenge) {
        this.currLaenge = this.data.editProdukt.laenge;
        this.formGroup.controls[this.fldLaengeKey].setValue(this.data.editProdukt.laenge);
      }
      if(this.data.editProdukt.breite) {
        this.currBreite = this.data.editProdukt.breite;
        this.formGroup.controls[this.fldBreiteKey].setValue(this.data.editProdukt.breite);
      }
      if(this.data.editProdukt.dicke) {
        this.currDicke = this.data.editProdukt.dicke;
        this.formGroup.controls[this.fldDickeKey].setValue(this.data.editProdukt.dicke);
      }
      if(this.data.editProdukt.menge)
        this.formGroup.controls[this.fldMengeKey].setValue(this.data.editProdukt.menge);

      if(this.data.editProdukt.mengeTotal)
        this.formGroup.controls[this.fldMengeTotalKey].setValue(this.data.editProdukt.mengeTotal);

      if(this.data.editProdukt.kulanz)
        this.formGroup.controls[this.fldKulanzKey].setValue(this.data.editProdukt.kulanz);

        if(this.data.editProdukt.spesen)
        this.formGroup.controls[this.fldSpesenKey].setValue(this.data.editProdukt.spesen);

      this.doCalc();
    } else // Neues Produkt wird erfasst (via Artikel-Auswahl oder direkt auf neuer Artikel)
    {
      this.currServicePosID = uuidv4();
      if(this.swissSettings.getWebConfig().debugMode)
        console.log("Neues Produkt wird erstellt: ", this.data.produkt);
      this.currAnzahl = 1.0;
      this.currEinheit = "Stk.";
      this.currPreissumme = formatCurrency(0, 'de-CH', 'CHF', '1.2-2').replace(',', '.');
      this.formGroup.controls[this.fldAnzahlKey].setValue(this.currAnzahl);
      this.formGroup.controls[this.fldEinheitKey].setValue(this.currEinheit);
      this.formGroup.controls[this.fldTotalPreisKey].setValue(this.currPreissumme);
      if (this.data && this.data.produkt) {
        if(this.swissSettings.getWebConfig().debugMode)
          console.log("Ein Produkt aus dem Artikelstamm wurde mitgegeben.");
        this.roFields = true;
        this.formGroup.controls[this.fldArtikelNummerKey].setValue(this.data.produkt?.productNo);
        this.formGroup.controls[this.fldBezeichnungKey].setValue(this.data.produkt?.shortText);
        if(this.data.produkt.stockUnit)
          this.currEinheit = this.data.produkt.stockUnit;
        this.formGroup.controls[this.fldEinheitKey].setValue(this.data.produkt?.stockUnit);
        if(this.data.produkt.salePrice) {
          this.currPreis = this.data.produkt.salePrice;
          this.formGroup.controls[this.fldPreisProEinheitKey].setValue(this.currPreis);
          this.currPreissumme = formatCurrency(this.data.produkt.salePrice, 'de-CH', 'CHF', '1.2-2').replace(',', '.');
          this.formGroup.controls[this.fldTotalPreisKey].setValue(this.currPreissumme);
        }
        this.doCalc()

        // Wenn der Dialog abgebrochen wird, müssen die vordefinierten Felder gelöscht werden.
        this.data.produkt = undefined;
      }
    }

    this.changePosition();
  }

  changePosition() {
    this.dialogRef.updatePosition({ top: '5px' });
  }

  doCalc() {
    switch (this.currEinheit.toLowerCase()) {
      case 'm1':
      case 'l1':
      case 'lm':
      case 'rk1':
        this.currMengeEinheit = '[m]';
        this.formGroup.controls[this.fldLaengeKey].setValidators(Validators.required);
        this.formGroup.controls[this.fldBreiteKey].removeValidators(Validators.required);
        this.formGroup.controls[this.fldDickeKey].removeValidators(Validators.required);
        this.currPreisFaktor = this.currLaenge / 1000.0;
        this.formGroup.controls[this.fldMengeKey].setValue(this.currPreisFaktor);
        this.formGroup.controls[this.fldMengeTotalKey].setValue(this._zahlenFormatPipe.round(this.currPreisFaktor * this.currAnzahl, 3));
        break;
      case 'm2':
        this.currMengeEinheit = "[m²]";
        this.formGroup.controls[this.fldLaengeKey].setValidators(Validators.required);
        this.formGroup.controls[this.fldBreiteKey].setValidators(Validators.required);
        this.formGroup.controls[this.fldDickeKey].removeValidators(Validators.required);
        this.currPreisFaktor = this.currLaenge * this.currBreite / 1000000.0;
        this.formGroup.controls[this.fldMengeKey].setValue(this.currPreisFaktor);
        this.formGroup.controls[this.fldMengeTotalKey].setValue(this._zahlenFormatPipe.round(this.currPreisFaktor * this.currAnzahl, 3));
        break;
      case 'm3':
        this.currMengeEinheit = '[m³]';
        this.formGroup.controls[this.fldLaengeKey].setValidators(Validators.required);
        this.formGroup.controls[this.fldBreiteKey].setValidators(Validators.required);
        this.formGroup.controls[this.fldDickeKey].setValidators(Validators.required);
        this.currPreisFaktor = this.currLaenge * this.currBreite * this.currDicke / 1000000000.0;
        this.formGroup.controls[this.fldMengeKey].setValue(this.currPreisFaktor);
        this.formGroup.controls[this.fldMengeTotalKey].setValue(this._zahlenFormatPipe.round(this.currPreisFaktor * this.currAnzahl, 3));
        break;
      default:
        this.formGroup.controls[this.fldLaengeKey].removeValidators(Validators.required);
        this.formGroup.controls[this.fldBreiteKey].removeValidators(Validators.required);
        this.formGroup.controls[this.fldDickeKey].removeValidators(Validators.required);
        this.formGroup.controls[this.fldMengeTotalKey].setValue(this.currAnzahl);
        this.formGroup.controls[this.fldMengeKey].setValue(this.currAnzahl);
        this.currPreisFaktor = 1.00;
        break;
    }

    this.currPreissummeValue = (this.currAnzahl * this.currPreis * this.currPreisFaktor);
    this.currPreissumme = formatCurrency((this.currPreissummeValue), 'de-CH', 'CHF', '1.2-2').replace(',', '.');
    this.formGroup.controls[this.fldTotalPreisKey].setValue(this.currPreissumme);

    this.currPreisProMassValue = (this.currPreis * this.currPreisFaktor);
    this.currPreisProMass = formatCurrency((this.currPreisProMassValue), 'de-CH', 'CHF', '1.2-2').replace(',', '.') + " / " + this.currEinheit;
    this.formGroup.controls[this.fldPreisProMassKey].setValue(this.currPreisProMass);
  }

  onAnzahlChange(event: Event) :void {
    if(event) {
      this.currAnzahl = Number((event.target as HTMLInputElement).value);
      this.doCalc();
    }
  }

  onEinheitChange(event: Event) :void {
    if(event) {
      this.currEinheit = (event.target as HTMLInputElement).value;
      this.doCalc();
    }
  }

  onLaengeChange(event: Event) :void {
    if(event) {
      this.currLaenge = Number((event.target as HTMLInputElement).value);
      this.doCalc();
    }
  }

  onBreiteChange(event: Event) :void {
    if(event) {
      this.currBreite = Number((event.target as HTMLInputElement).value);
      this.doCalc();
    }
  }

  onDickeChange(event: Event) :void {
    if(event) {
      this.currDicke = Number((event.target as HTMLInputElement).value);
      this.doCalc();
    }
  }

  onPreisChange(event: Event) :void {
    if(event) {
      this.currPreis = Number((event.target as HTMLInputElement).value);
      this.doCalc();
    }
  }

  save(): void {
    // Neues Produkt wird in IndexedDB gespeichert
    if(this.swissSettings.getWebConfig().debugMode)
      console.log("FormValues: ", this.formGroup.value);

    let createdByWL = false;
    let rowID: any = null;
    if(this.data.editProdukt) {
      createdByWL = this.data.editProdukt!.createdByWL
      rowID = this.data.editProdukt!.rowID
    }

    this.productEntry = {
      rowID: rowID,
      servicePosID: this.currServicePosID,
      serviceID: this.data.sA_Termin!.serviceID,
      datum: this.data.sA_Termin!.startTime!,
      mitarbeiter: this.data.sA_Anwender!,
      ausArtikelStamm: !!this.data.produkt,
      artikelnummer: this.formGroup.controls[this.fldArtikelNummerKey].value,
      bezeichnung: this.formGroup.controls[this.fldBezeichnungKey].value,
      anzahl: this.formGroup.controls[this.fldAnzahlKey].value,
      einheit: this.formGroup.controls[this.fldEinheitKey].value,
      preisProEinheit: this.formGroup.controls[this.fldPreisProEinheitKey].value,
      preisTotal: this.currPreissummeValue,
      laenge: this.formGroup.controls[this.fldLaengeKey].value,
      breite: this.formGroup.controls[this.fldBreiteKey].value,
      dicke: this.formGroup.controls[this.fldDickeKey].value,
      menge: this.formGroup.controls[this.fldMengeKey].value,
      mengeTotal: this.formGroup.controls[this.fldMengeTotalKey].value,
      spesen: this.formGroup.controls[this.fldSpesenKey].value,
      kulanz: this.formGroup.controls[this.fldKulanzKey].value,
      createdByWL: createdByWL,
      deleted: false,
      uploaded: false,
      modifiedInMobile: true
    }

    this.dialogRef.close(this.productEntry);
  }

}
